export default __webpack_public_path__ + "static/media/Mochila.d2137bc0.jpg";